import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  config: Observable<any>;

  constructor(private httpClient: HttpClient) {
      this.config = this.httpClient.get(`/assets/contents/config.json`).pipe(shareReplay(1));
  }

  getConfig(key: string, defaultValue: any = ''): Observable<any> {
      return this.config.pipe(map(config => config[key] || defaultValue));
  } 
}
